/** @jsxImportSource @emotion/react */

import React, { forwardRef } from 'react';

import { MainBlock } from './styles';
import UDText from '../text';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: JSX.Element;
  color?: string;
  hoverColor?: string;
  disabledColor?: string;
  width?: number;
  height?: number;
  disabled?: boolean;
  centered?: boolean;
}

const UDEmptyButton = forwardRef<HTMLButtonElement, IProps>((props, ref) => {
  const { icon, color = '#1a1a29', children, centered, ...rest } = props;

  return (
    <MainBlock ref={ref} color={color} centered={centered ?? true} {...rest}>
      {icon}
      {children && (
        <UDText style={{ color: 'inherit', fontSize: 'inherit' }} type={'subhead'}>
          {children}
        </UDText>
      )}
    </MainBlock>
  );
});

export default UDEmptyButton;
